import type { ResourceProps } from 'react-admin';
import { CanAccess } from 'react-admin';
import SecurityIcon from '@mui/icons-material/Security';
import { type ComponentType, lazy } from 'react';
import { resources } from '@repo/c360-ra-components';

const AsyncPageCreate = lazy(() => import('./create'));
const AsyncPageEdit = lazy(() => import('./edit'));
const AsyncPageList = lazy(() => import('./list'));
const AsyncPageShow = lazy(() => import('./show'));

const ProtectedList = () => (
  <CanAccess resource={resources.roles} action="list">
    <AsyncPageList />
  </CanAccess>
);

export default {
  list: ProtectedList as ComponentType<any>,
  create: AsyncPageCreate as ComponentType<any>,
  edit: AsyncPageEdit as ComponentType<any>,
  show: AsyncPageShow as ComponentType<any>,
  icon: SecurityIcon as ComponentType<any>,
} as ResourceProps;
